import React, { useEffect, useState, useCallback } from 'react';
import _ from 'lodash';
import { Paper, Table, TableCell, TableContainer, TableRow, Button, Typography, TextField } from '@material-ui/core';
import { makeStyles, alpha, lighten } from '@material-ui/core/styles';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
//import useStyles from '@jumbo/components/Mantenimiento/MantenimientoStyle';
import Toolbar from '@material-ui/core/Toolbar';
import CmtSearch from '@coremat/CmtSearch';
import CmtCard from '@coremat/CmtCard';
import CmtCardContent from '@coremat/CmtCard/CmtCardContent';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import AddBoxIcon from '@material-ui/icons/AddBox';
import {
  SET_OPENCARTERAGRUPODIALOG,
  SET_CLOSECARTERAGRUPODIALOG,
  SET_CARTERAGRUPOSELECT,
} from '@jumbo/constants/ActionTypes';
import Autocompetesinapp from 'routes/Ejecucion/utils/Autocompetesinapp';
import Pickersinapp from 'routes/Ejecucion/utils/Pickersinapp';
import { getComparator, stableSort } from '@jumbo/utils/tableHelper';
import useForm from '@jumbo/utils/useForm';
import { useDispatch, useSelector } from 'react-redux';
import { ValorSelect } from 'routes/Ejecucion/utils/Helper';
import TableUtils from '@jumbo/utils/TableUtils';
import ReactExport from 'react-export-excel';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import NoRecordFound from '@jumbo/components/ListadoEjecucion/NoRecordFound';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';
import Swal from 'sweetalert2';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import {
  getCarterascobros,
  addCarteraCobros,
  updCarteraCobros,
  Eliminarcarteracobros,
  getCarterascobrosInicio,
  getCarterascobrosbyid,
  getCarterasPresupuesto,
  addCarteraCobrosDetalle,
  getCarterascobrosDetalle,
  Eliminarcarteracobrosdetalle,

  // getCobronoregularesbyid,
  // updCobrosnoregulares,
  // EliminarCobronoregular,
  //
} from '../../redux/actions/Mantenimiento';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import EditIcon from '@material-ui/icons/Edit';

const headCells = [
  {
    id: 'carteras',
    numeric: false,
    disablePadding: false,
    label: 'Carteras',
  },
];

function TableHeadFormulario({ classes, order, orderBy, onRequestSort }) {
  const onSortOrderChange = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={onSortOrderChange(headCell.id)}>
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell align="right">Acción</TableCell>
      </TableRow>
    </TableHead>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(4),
    backgroundColor: lighten(theme.palette.background.paper, 0.1),
  },
  container: {
    maxHeight: 350,
    minHeight: 350,
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  titleRoot: {
    marginBottom: 2,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.common.dark,
  },
  button: {
    textTransform: 'none',
  },
  buttonerror: {
    textTransform: 'none',
    backgroundColor: theme.palette.error.main,
    color: 'white',
  },
  roottoolbar: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(2),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: alpha(theme.palette.secondary.light, 0.15),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
  chipsRoot: {
    display: 'flex',
    justifyContent: 'center',
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    '& .MuiTypography-h6': {
      fontSize: 16,
      color: theme.palette.common.black,
    },
    background: theme.palette.primary.main,
  },
  textlabel: {
    '& .MuiFormLabel-root': {
      color: '#232322',
    },
  },
  divider: {
    background: theme.palette.primary.main,
  },
  input: {
    '& .MuiTextField-root': {
      width: '50%',
    },
  },
  buscar: {
    '& .CmtSearch-root': {
      justifyContent: 'flex-end',
      paddingRight: theme.spacing(2),
    },
  },
  CmtCard: {
    marginBottom: 10,
  },
  CmtCardSidebar: {
    marginRight: 10,
  },
  listItem: {
    color: 'black!important',
    fontWeight: '500',
    textDecoration: 'none!important',
    height: 40,
    width: 'calc(100% - 16px)',
    borderRadius: '0 20px 20px 0',
    paddingLeft: 24,
    paddingRight: 12,
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: `${'white'}!important`,
      pointerEvents: 'none',
      '& .list-item-icon': {
        color: `${'white'}!important`,
      },
    },
    '& .list-item-icon': {
      marginRight: 16,
    },
  },
}));

const defaultFormState = {
  carteraGrupoID: null,
  descripcion: '',
  usuarioID: null,
};

export default function AgrupacionCartera() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState('');
  const { CarteraGrupo, CarteraGrupoSelect, carteras, CarteraGrupoDetalle } = useSelector(
    ({ mantenimiento }) => mantenimiento,
  );
  const { usuarioID } = useSelector(({ auth }) => auth.authUser);
  const [TourOperator, setTourOperator] = useState('-10000');
  const [data, setData] = useState([]);
  const [orderBy, setOrderBy] = React.useState('descripcion');
  const [order, setOrder] = React.useState('asc');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  useEffect(() => {
    dispatch(getCarterascobrosInicio());
    dispatch(getCarterasPresupuesto());
  }, [dispatch]);

  useEffect(() => {
    if (CarteraGrupoSelect.carteraGrupoID) {
      dispatch(getCarterascobrosDetalle(CarteraGrupoSelect.carteraGrupoID));
    }
  }, [CarteraGrupoSelect]);

  useEffect(() => {
    function getFilteredArray(entities, _searchTerm) {
      if (_searchTerm.length === 0) {
        return CarteraGrupoDetalle;
      }
      return TableUtils.filterArrayByString(CarteraGrupoDetalle, _searchTerm);
    }
    if (CarteraGrupoDetalle) {
      setData(getFilteredArray(CarteraGrupoDetalle, searchTerm));
    }
  }, [CarteraGrupoDetalle, searchTerm]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrderBy(property);
    setOrder(isAsc ? 'desc' : 'asc');
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <PageContainer heading="Agrupación de Carteras">
      {/* <div className={classes.root}>
            <Paper className={classes.paper}>
            <Toolbar className={classes.roottoolbar}>
                <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
                Listado de Hoteles
                </Typography>
                <React.Fragment>
                <CmtSearch onChange={e => setSearchTerm(e.target.value)} value={searchTerm} border={false} onlyIcon />
                </React.Fragment>
            </Toolbar>
            </Paper>
            </div>  */}

      <Grid container>
        <Grid item xs={3}>
          <CmtCard className={classes.CmtCardSidebar}>
            <Toolbar className={classes.roottoolbar}>
              <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
                Grupos
              </Typography>
              <IconButton size="medium" color="secondary">
                <AddBoxIcon onClick={() => dispatch({ type: SET_OPENCARTERAGRUPODIALOG, payload: defaultFormState })} />
              </IconButton>
            </Toolbar>

            <List>
              {CarteraGrupo.length > 0 &&
                CarteraGrupo.map(grupo => (
                  <ListItem
                    button
                    selected={CarteraGrupoSelect.carteraGrupoID === grupo.carteraGrupoID}
                    onClick={() => {
                      dispatch({ type: SET_CARTERAGRUPOSELECT, payload: grupo });
                    }}
                    key={grupo.carteraGrupoID}
                    activeClassName="active"
                    className={classes.listItem}>
                    <ListItemText primary={grupo.descripcion} disableTypography />
                  </ListItem>
                ))}
            </List>
          </CmtCard>
        </Grid>

        <Grid item xs={9}>
          <CmtCard>
            <Toolbar className={classes.roottoolbar}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={6}>
                  <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'flex-start' }}>
                    <div style={{ marginTop: 15 }}>
                      <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
                        {CarteraGrupoSelect.descripcion}
                      </Typography>
                    </div>

                    <div>
                      <IconButton color="secondary">
                        <EditIcon onClick={() => dispatch(getCarterascobrosbyid(CarteraGrupoSelect.carteraGrupoID))} />
                      </IconButton>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div style={{ flexDirection: 'row', display: 'flex', marginTop: 5 }}>
                    {carteras.length > 0 && (
                      <Autocompetesinapp
                        options={carteras}
                        name="Carteras"
                        value={carteras.find(x => x.value === TourOperator.toString())}
                        onChange={(event, newValue) => {
                          setTourOperator(newValue.value);
                        }}
                        fullWidth
                      />
                    )}

                    <IconButton size="medium" color="secondary">
                      <AddBoxIcon
                        onClick={() => {
                          let Detalle = {
                            carteraGrupoID: CarteraGrupoSelect.carteraGrupoID,
                            tourOpGroupID: TourOperator.toString(),
                            usuarioID: usuarioID,
                          };
                          dispatch(addCarteraCobrosDetalle(Detalle));
                        }}
                      />
                    </IconButton>
                  </div>
                </Grid>
              </Grid>
            </Toolbar>

            <TableContainer className={classes.container}>
              <Table stickyHeader className={classes.table} aria-labelledby="tableTitle" aria-label="sticky enhanced table">
                <TableHeadFormulario classes={classes} order={order} orderBy={orderBy} onRequestSort={handleRequestSort} />

                <TableBody>
                  {!!data.length ? (
                    stableSort(data, getComparator(order, orderBy))
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, index) => (
                        <TableRow hovers tabIndex={-1} key={row.formAppID}>
                          <TableCell>{row.tourOpGroup}</TableCell>
                          <TableCell align="right">
                            <IconButton size="medium" color="secondary">
                              <DeleteForeverIcon
                                onClick={() => {
                                  Swal.fire({
                                    title: '¿Estás seguro(a) de Eliminar?',
                                    text: '¡No podrás recuperar este cambio!',
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonColor: 'red',
                                    confirmButtonText: 'Si, Eliminar',
                                    cancelButtonText: 'No, Mantener',
                                  }).then(result => {
                                    if (result.value) {
                                      let value = {
                                        carteraGrupoID: CarteraGrupoSelect.carteraGrupoID,
                                        carteraGrupoDetalleID: row.carteraGrupoDetalleID,
                                      };
                                      dispatch(Eliminarcarteracobrosdetalle(value));
                                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                                      Swal.fire('Cancelado', 'No se realizó este cambio :)', 'error');
                                    }
                                  });
                                }}
                              />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow style={{ height: 53 * 6 }}>
                      <TableCell colSpan={7} rowSpan={10}>
                        <NoRecordFound>No se han encontrado registros.</NoRecordFound>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 20, 50]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              labelRowsPerPage="Filas por página"
            />
          </CmtCard>
        </Grid>
      </Grid>
      <FormDialog />
    </PageContainer>
  );
}

function FormDialog(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const formDialog = useSelector(({ mantenimiento }) => mantenimiento.dialogCarteraGrupo);
  const { form, setForm } = useForm(defaultFormState);
  const { usuarioID } = useSelector(({ auth }) => auth.authUser);

  const initDialog = useCallback(() => {
    if (formDialog.data) {
      setForm({ ...formDialog.data });
    }
  }, [formDialog.data, setForm]);

  useEffect(() => {
    if (formDialog.props.open) {
      initDialog();
    }
  }, [formDialog.props.open, initDialog]);

  function closeComposeDialog() {
    dispatch({ type: SET_CLOSECARTERAGRUPODIALOG, payload: false });
  }

  return (
    <>
      <Dialog open={formDialog.props.open} className={classes.dialogRoot} fullWidth maxWidth="sm">
        <DialogTitle className={classes.dialogTitleRoot}> Grupo de Cartera</DialogTitle>
        <DialogContent dividers>
          <div className={classes.root}>
            <TextField
              className={classes.textlabel}
              fullWidth
              label="Descripción"
              variant="outlined"
              value={form.descripcion}
              onChange={value => setForm(_.set({ ...form }, 'descripcion', value.target.value))}
              //  size="small"
              style={{ marginBottom: 10 }}
            />
          </div>

          <Box display="flex" justifyContent="flex-end" my={4}>
            <Button variant="contained" onClick={() => closeComposeDialog()}>
              Cancelar
            </Button>
            {form.carteraGrupoID !== null && (
              <Box ml={2}>
                <Button
                  variant="contained"
                  className={classes.buttonerror}
                  onClick={() => {
                    form.usuarioID = usuarioID;
                    Swal.fire({
                      title: '¿Estás seguro(a) de Eliminar?',
                      text: '¡No podrás recuperar este cambio!',
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonColor: 'red',
                      confirmButtonText: 'Si, Eliminar',
                      cancelButtonText: 'No, Mantener',
                    }).then(result => {
                      if (result.value) {
                        dispatch(Eliminarcarteracobros(form.carteraGrupoID));
                      } else if (result.dismiss === Swal.DismissReason.cancel) {
                        Swal.fire('Cancelado', 'No se realizó este cambio :)', 'error');
                      }
                    });
                  }}>
                  Eliminar
                </Button>
              </Box>
            )}
            <Box ml={2}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => {
                  form.usuarioID = usuarioID;

                  if (form.carteraGrupoID === null) {
                    //if((form.presupuestoItemID !== "-10000") && (form.hotelID !== "-10000") && (form.tourOpID !== "-10000") && form.importe && form.fechaDummy ){
                    dispatch(addCarteraCobros(form));
                    // }
                  } else {
                    dispatch(updCarteraCobros(form));
                  }
                }}>
                Guardar
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
